export function removeAccents(texto) {
    const mapaAcentos = {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        ü: 'u',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U',
        Ü: 'U',
        à: 'a',
        è: 'e',
        ì: 'i',
        ò: 'o',
        ù: 'u',
        À: 'A',
        È: 'E',
        Ì: 'I',
        Ò: 'O',
        Ù: 'U'
    };

    return texto.replace(/[áéíóúüÁÉÍÓÚÜàèìòùÀÈÌÒÙ]/g, (letra) => mapaAcentos[letra] || letra);
}
